import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="footer-container">
                <div className="footer-left">

                    <a target="_blank" className="brand-name" href="https://amservices.eu/">AM SERVICES</a>
                </div>
                <div className="footer-right">
                    <p>© {new Date().getFullYear()} — Tous droits réservés</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;